import { useEffect, useState } from 'react';

import { configurePurchases } from 'utils/revenueCat';

export const usePremiumEntitlement = ({ appUserId, oldProgramPayment = false }) => {
  // Keyed by the id it was resolved for, so a user switch never reads the previous user's tier.
  const [resolved, setResolved] = useState({ id: null, entitlements: null });

  useEffect(() => {
    // Drop the old answer so returning to an earlier user re-checks instead of reusing it.
    setResolved({ id: null, entitlements: null });
    if (!appUserId || oldProgramPayment) return undefined;

    let isCurrentUser = true;

    const fetchCustomerInfo = async () => {
      try {
        const { entitlements } = await configurePurchases(appUserId).getCustomerInfo();
        if (isCurrentUser) setResolved({ id: appUserId, entitlements });
      } catch (error) {
        console.error('Error fetching customer info: ', error);
        if (isCurrentUser) setResolved({ id: appUserId, entitlements: {} });
      }
    };
    fetchCustomerInfo();

    return () => {
      isCurrentUser = false;
    };
  }, [appUserId, oldProgramPayment]);

  const entitlements = resolved.id === appUserId ? resolved.entitlements : null;

  return {
    isPremium: oldProgramPayment || Boolean(entitlements?.active?.Premium),
    isPending: Boolean(appUserId) && !oldProgramPayment && entitlements === null,
  };
};
